// Translation: English > Terminology
const terminology = Object.freeze({
	agent: 'Agent',
	agent_one: 'Agent',
	agent_other: 'Agents',
	agents: 'Agents',
	agentStatusItems: {
		deleted: 'Deleted',
		draft: 'Draft',
		onboarded: 'Onboarded'
	},
	agentWithCount_one: '{{count}} agent',
	agentWithCount_other: '{{count}} agents',
	agentWithId: 'Agent {{id}}',
	asset: 'Asset',
	asset_one: 'Asset',
	asset_other: 'Assets',
	assets: 'Assets',
	assetWithCount_one: '{{count}} asset',
	assetWithCount_other: '{{count}} assets',
	assetWithVersion: '{{name}} [{{version}}]',
	automode: 'AutoMode',
	benchmark: 'Benchmark',
	benchmark_one: 'Benchmark',
	benchmark_other: 'Benchmarks',
	benchmarks: 'Benchmarks',
	benchmarkStatusItems: {
		calculate_scores: 'Recalculating',
		completed: 'Completed',
		failed: 'Failed',
		in_progress: 'In progress'
	},
	benchmarkWithCount_one: '{{count}} benchmark',
	benchmarkWithCount_other: '{{count}} benchmarks',
	benchmarkWithId: 'Benchmark {{id}}',
	categories: 'Categories',
	category: 'Category',
	category_one: 'Category',
	category_other: 'Categories',
	categoryWithCount_one: '{{count}} category',
	categoryWithCount_other: '{{count}} categories',
	character: 'Character',
	character_one: 'Character',
	character_other: 'Characters',
	characters: 'Characters',
	characterWithCount_one: '{{count}} character',
	characterWithCount_other: '{{count}} characters',
	column: 'Column',
	column_one: 'Column',
	column_other: 'Columns',
	columns: 'Columns',
	columnWithCount_one: '{{count}} column',
	columnWithCount_other: '{{count}} columns',
	corpora: 'Corpora',
	corpus: 'Corpus',
	corpus_one: 'Corpus',
	corpus_other: 'Corpora',
	corpusPrivacyTypeItems: {
		Private: 'Private',
		Public: 'Public'
	},
	corpusStatusItems: {
		deleted: 'Deleted',
		failed: 'Failed',
		onboarded: 'Onboarded',
		onboarding: 'Onboarding'
	},
	corpusWithCount_one: '{{count}} corpus',
	corpusWithCount_other: '{{count}} corpora',
	corpusWithId: 'Corpus {{id}}',
	credit: 'Credit',
	credit_one: 'Credit',
	credit_other: 'Credits',
	creditAsRange: '{{low}}–{{high}} credits',
	credits: 'Credits',
	creditWithCount_one: '{{count}} credit',
	creditWithCount_other: '{{count}} credits',
	data: 'Data',
	dataset: 'Dataset',
	dataset_one: 'Dataset',
	dataset_other: 'Datasets',
	datasetMetadataTypeItems: {
		age: 'Age',
		gender: 'Gender',
		other: 'Other',
		race: 'Race',
		split: 'Split',
		topic: 'Topic'
	},
	datasets: 'Datasets',
	datasetStatusItems: {
		deleted: 'Deleted',
		failed: 'Failed',
		onboarded: 'Onboarded',
		onboarding: 'Onboarding'
	},
	datasetUsageTypeItems: {
		development: 'Development',
		developmentInShort: 'Dev',
		training: 'Training',
		trainingInShort: 'Train'
	},
	datasetWithCount_one: '{{count}} dataset',
	datasetWithCount_other: '{{count}} datasets',
	datasetWithFunction: '{{function}} dataset',
	datasetWithId: 'Dataset {{id}}',
	dataSubTypeItems: {
		boolean: 'Boolean',
		file: 'File',
		json: 'JSON',
		labeledImage: 'Labeled image',
		labeledText: 'Labeled text',
		number: 'Number'
	},
	dataTypeItems: {
		audio: 'Audio',
		image: 'Image',
		label: 'Label',
		number: 'Number',
		text: 'Text',
		video: 'Video'
	},
	decisionInputItems: {
		comparison: 'Comparison',
		passthrough: 'Passthrough'
	},
	draft: 'Draft',
	file: 'File',
	file_one: 'File',
	file_other: 'Files',
	files: 'Files',
	fileStatusItems: {
		canceled: 'Canceled',
		canceling: 'Canceling',
		completed: 'Completed',
		failed: 'Failed',
		in_progress: 'In progress',
		pending: 'Pending'
	},
	fileWithCount_one: '{{count}} file',
	fileWithCount_other: '{{count}} files',
	fileWithId: 'File {{id}}',
	finetune: 'FineTune',
	function: 'Function',
	function_one: 'Function',
	function_other: 'Functions',
	functionInputItems: {
		action: 'Action',
		apl_qfactor: 'Compression quality factor',
		audio: 'Audio',
		chunk_max_seconds: 'Maximum chunk size (seconds)',
		context: 'Context',
		data: 'Data',
		dialect: 'Dialect',
		dialect_in: 'Dialect in',
		dialect_out: 'Dialect out',
		domain: 'Domain',
		enable_denormalizer: 'Enable denormalizer',
		featuretypes: 'Feature types',
		format: 'Format',
		frequency_penalty: 'Frequency penalty',
		gender: 'Gender',
		history: 'History',
		image: 'Image',
		inputtext: 'Input text',
		is_medical: 'Medical',
		language: 'Language',
		lowercase_latin: 'Lowercase Latin',
		max_duration_seconds: 'Maximum duration seconds',
		max_new_tokens: 'Maximum new tokens',
		max_tokens: 'Maximum tokens',
		max_tokens_to_sample: 'Maximum tokens to sample',
		min_confidence: 'Minimum confidence',
		min_duration_off: 'Minimum duration off',
		min_duration_on: 'Minimum duration on',
		modelid: 'Model ID',
		next_state: 'Next state',
		normalize_arabic: 'Normalize Arabic',
		num_return_sequences: 'Number of returned sequences',
		numResults: 'Number of results',
		offset: 'Offset',
		onset: 'Onset',
		option_index: 'Option index',
		output: 'Output',
		payload: 'Payload',
		pitch: 'Pitch',
		presence_penalty: 'Presence penalty',
		prompt: 'Prompt',
		query: 'Query',
		remove_accents: 'Remove accents',
		remove_arabic_diacritics: 'Remove Arabic diacritics',
		remove_arabic_superfluous: 'Remove Arabic superfluous',
		remove_punctuation: 'Remove punctuation',
		result_format: 'Result format',
		script: 'Script',
		script_in: 'Script in',
		script_out: 'Script out',
		seed: 'Seed',
		session_id: 'Session ID',
		settings: 'Settings',
		similarity_boost: 'Similarity boost',
		source_audio: 'Source audio',
		source_supplier: 'Source supplier',
		sourcelanguage: 'Source language',
		speed: 'Speed',
		stability: 'Stability',
		style: 'Style',
		supplier_model_id: 'Supplier model ID',
		tags: 'Tags',
		target_supplier: 'Target supplier',
		targetimage: 'Target image',
		targetlanguage: 'Target language',
		targetlanguages: 'Target languages',
		temperature: 'Temperature',
		template: 'Template',
		text: 'Text',
		top_k: 'Top K sampling value',
		top_p: 'Top P sampling value',
		transcript: 'Transcript',
		type: 'Type',
		url: 'URL',
		video: 'Video',
		voice: 'Voice',
		voice_id: 'Voice ID'
	},
	functionItems: {
		'activity-detection': 'Activity detection',
		'asr-age-classification': 'ASR age classification',
		'asr-gender-classification': 'ASR gender classification',
		'asr-quality-estimation': 'ASR quality estimation',
		'audio-forced-alignment': 'Audio forced alignment',
		'audio-generation-metric': 'Audio generation metric',
		'audio-reconstruction': 'Audio reconstruction',
		'audio-source-separation': 'Audio source separation',
		'audio-transcript-analysis': 'Audio transcript analysis',
		'audio-transcript-improvement': 'Audio transcript improvement',
		'auto-mask-generation': 'Mask generation',
		'benchmark-scoring-asr': 'Benchmark scoring ASR',
		'benchmark-scoring-mt': 'Benchmark scoring MT',
		'classification-metric': 'Classification metric',
		default: 'Default',
		'detect-language-from-text': 'Detect language from text',
		diacritization: 'Diacritization',
		'dialect-detection': 'Dialect detection',
		'emotion-detection': 'Emotion detection',
		'entity-linking': 'Entity linking',
		'entity-sentiment-analysis': 'Entity sentiment analysis',
		'expression-detection': 'Expression detection',
		'extract-audio-from-video': 'Extract audio from video',
		'facial-recognition': 'Facial recognition',
		'fill-text-mask': 'Fill text mask',
		'image-analysis': 'Image analysis',
		'image-and-video-analysis': 'Image and video analysis',
		'image-captioning': 'Image captioning',
		'image-compression': 'Image compression',
		'image-content-moderation': 'Image content moderation',
		'image-label-detection': 'Image label detection',
		'image-manipulation': 'Image manipulation',
		'intent-recognition': 'Intent recognition',
		'keyword-extraction': 'Keyword extraction',
		'language-identification': 'Language identification',
		'language-identification-audio': 'Audio language identification',
		loglikelihood: 'Log likelihood',
		'metric-aggregation': 'Metric aggregation',
		'named-entity-recognition': 'Named entity recognition',
		'object-detection': 'Object detection',
		ocr: 'OCR',
		'offensive-language-identification': 'Offensive language identification',
		paraphrasing: 'Paraphrasing',
		'question-answering': 'Question answering',
		'referenceless-audio-generation-metric': 'Referenceless audio generation metric',
		'referenceless-text-generation-metric': 'Referenceless text generation metric',
		'referenceless-text-generation-metric-default': 'Referenceless text generation metric (default)',
		'scene-detection': 'Scene detection',
		'script-execution': 'Script execution',
		search: 'Search',
		'sentiment-analysis': 'Sentiment analysis',
		'speaker-diarization-audio': 'Speaker diarization audio',
		'speaker-diarization-video': 'Speaker diarization video',
		'speaker-recognition': 'Speaker recognition',
		'speech-classification': 'Speech classification',
		'speech-embedding': 'Speech embedding',
		'speech-non-speech-classification': 'Speech/non-speech classification',
		'speech-recognition': 'Speech recognition',
		'speech-synthesis': 'Speech synthesis',
		'speech-translation': 'Speech translation',
		'split-on-linebreak': 'Split on linebreak',
		'split-on-silence': 'Split on silence',
		subtitling: 'Subtitling',
		'subtitling-translation': 'Subtitling translation',
		summarization: 'Summarization',
		'syntax-analysis': 'Syntax analysis',
		'table-question-answering': 'Table question answering',
		'text-classification': 'Text classification',
		'text-content-moderation': 'Text content moderation',
		'text-denormalization': 'Text denormalization',
		'text-detection': 'Text detection',
		'text-embedding': 'Text embedding',
		'text-generation': 'Text generation (LLM)',
		'text-generation-metric': 'Text generation metric',
		'text-generation-metric-aggregation': 'Text generation metric (aggregated)',
		'text-generation-metric-default': 'Text generation metric (default)',
		'text-normalization': 'Text normalization',
		'text-reconstruction': 'Text reconstruction',
		'text-segmentation': 'Text segmentation',
		'text-spam-detection': 'Text spam detection',
		'text-summarization': 'Text summarization',
		'text-to-image-generation': 'Text to image generation',
		'text-transformation': 'Text transformation',
		tools: 'Tools',
		'topic-classification': 'Topic classification',
		'topic-modeling': 'Topic modeling',
		translation: 'Translation',
		utilities: 'Utilities',
		'video-content-moderation': 'Video content moderation',
		'video-forced-alignment': 'Video forced alignment',
		'video-generation': 'Video generation',
		'video-label-detection': 'Video label detection',
		'video-understanding': 'Video understanding',
		'viseme-generation': 'Viseme generation',
		'voice-activity-detection': 'Voice activity detection',
		'voice-cloning': 'Voice cloning',
		'zero-shot-classification': 'Zero-shot classification'
	},
	functionOutputItems: {
		audio: 'Audio',
		confidence: 'Confidence',
		data: 'Data',
		image: 'Image',
		input: 'Input',
		label: 'Label',
		score: 'Score',
		text: 'Text',
		video: 'Video'
	},
	functions: 'Functions',
	functionWithCount_one: '{{count}} function',
	functionWithCount_other: '{{count}} functions',
	hypotheses: 'Hypotheses',
	hypothesis: 'Hypothesis',
	hypothesis_one: 'Hypothesis',
	hypothesis_other: 'Hypotheses',
	input: 'Input',
	input_one: 'Input',
	input_other: 'Inputs',
	inputLanguage: 'Input language',
	inputLanguage_one: 'Input language',
	inputLanguage_other: 'Input languages',
	inputLanguages: 'Input languages',
	inputLanguageWithCount_one: '{{count}} input language',
	inputLanguageWithCount_other: '{{count}} input languages',
	inputs: 'Inputs',
	inputWithCount_one: '{{count}} input',
	inputWithCount_other: '{{count}} inputs',
	label: 'Label',
	label_one: 'Label',
	label_other: 'Labels',
	labels: 'Labels',
	labelWithCount_one: '{{count}} label',
	labelWithCount_other: '{{count}} labels',
	language: 'Language',
	language_one: 'Language',
	language_other: 'Languages',
	languages: 'Languages',
	languageWithCount_one: '{{count}} language',
	languageWithCount_other: '{{count}} languages',
	license: 'License',
	metadata: 'Metadata',
	metric: 'Metric',
	metric_one: 'Metric',
	metric_other: 'Metrics',
	metricInputItems: {
		hypotheses: 'Hypotheses',
		references: 'References',
		score_identifier: 'Score identifier',
		sources: 'Sources'
	},
	metrics: 'Metrics',
	metricStatusItems: {
		deleted: 'Deleted',
		deleting: 'Deleting',
		disabled: 'Disabled',
		enabling: 'Enabling',
		failed: 'Failed',
		hidden: 'Hidden',
		onboarded: 'Onboarded',
		onboarding: 'Onboarding',
		training: 'Training'
	},
	metricWithCount_one: '{{count}} metric',
	metricWithCount_other: '{{count}} metrics',
	metricWithId: 'Metric {{id}}',
	model: 'Model',
	model_one: 'Model',
	model_other: 'Models',
	modelNodeInstanceTypeItems: {
		ai: 'AI',
		reconstructor: 'Reconstructor',
		segmentor: 'Segmentor',
		utility: 'Utility'
	},
	models: 'Models',
	modelStatusItems: {
		deleted: 'Deleted',
		deleting: 'Deleting',
		disabled: 'Disabled',
		enabling: 'Enabling',
		failed: 'Failed',
		hidden: 'Hidden',
		onboarded: 'Onboarded',
		onboarding: 'Onboarding',
		training: 'Training'
	},
	modelWithCount_one: '{{count}} model',
	modelWithCount_other: '{{count}} models',
	modelWithId: 'Model {{id}}',
	nodeTypeItems: {
		decision: 'Decision',
		function: 'Function',
		input: 'Input',
		metric: 'Metric',
		model: 'Model',
		output: 'Output',
		router: 'Router',
		script: 'Script'
	},
	normalization: 'Normalization',
	normalization_one: 'Normalization',
	normalization_other: 'Normalizations',
	normalizationItems: {
		default: 'Default configuration',
		'denormalize spoken text': 'Denormalize spoken text',
		'lowercase text': 'Lowercase text',
		'normalize default arabic': 'Normalize default Arabic',
		'normalize full arabic': 'Normalize full Arabic',
		'normalize quotes': 'Normalize quotes',
		'normalize spoken text': 'Normalize spoken text',
		'remove arabic superfluous': 'Remove Arabic superfluous',
		'remove default arabic diacritics': 'Remove default Arabic diacritics',
		'remove emails': 'Remove emails',
		'remove emojis': 'Remove emojis',
		'remove full arabic diacritics': 'Remove full Arabic diacritics',
		'remove html tags': 'Remove HTML tags',
		'remove kashida dagger': 'Remove Kashida Dagger',
		'remove phone numbers': 'Remove phone numbers',
		'remove punctuations': 'Remove punctuations',
		'remove urls': 'Remove URLs',
		'tokenize text': 'Tokenize text'
	},
	normalizations: 'Normalizations',
	output: 'Output',
	output_one: 'Output',
	output_other: 'Outputs',
	outputLanguage: 'Output language',
	outputLanguage_one: 'Output language',
	outputLanguage_other: 'Output languages',
	outputLanguages: 'Output languages',
	outputLanguageWithCount_one: '{{count}} output language',
	outputLanguageWithCount_other: '{{count}} output languages',
	outputs: 'Outputs',
	outputWithCount_one: '{{count}} output',
	outputWithCount_other: '{{count}} outputs',
	owner: 'Owner',
	owner_one: 'Owner',
	owner_other: 'Owners',
	owners: 'Owners',
	ownerWithCount_one: '{{count}} owner',
	ownerWithCount_other: '{{count}} owners',
	pipeline: 'Pipeline',
	pipeline_one: 'Pipeline',
	pipeline_other: 'Pipelines',
	pipelineDraft: 'Pipeline draft',
	pipelineDraft_one: 'Pipeline draft',
	pipelineDraft_other: 'Pipeline drafts',
	pipelineDrafts: 'Pipeline drafts',
	pipelineDraftWithCount_one: '{{count}} pipeline draft',
	pipelineDraftWithCount_other: '{{count}} pipeline drafts',
	pipelineDraftWithId: 'Pipeline draft {{id}}',
	pipelines: 'Pipelines',
	pipelineTemplate: 'Pipeline template',
	pipelineTemplate_one: 'Pipeline template',
	pipelineTemplate_other: 'Pipeline templates',
	pipelineTemplates: 'Pipeline templates',
	pipelineTemplateWithCount_one: '{{count}} pipeline template',
	pipelineTemplateWithCount_other: '{{count}} pipeline templates',
	pipelineTemplateWithId: 'Pipeline template {{id}}',
	pipelineWithCount_one: '{{count}} pipeline',
	pipelineWithCount_other: '{{count}} pipelines',
	pipelineWithId: 'Pipeline {{id}}',
	pricingTypeItems: {
		free: 'Free',
		oneTime: 'One time',
		perUse: 'Per use'
	},
	privacy: 'Privacy',
	privacyTypeItems: {
		private: 'Private',
		public: 'Public',
		restricted: 'Restricted'
	},
	reference: 'Reference',
	referenceless: 'Referenceless',
	report: 'Report',
	report_one: 'Report',
	report_other: 'Reports',
	reports: 'Reports',
	reportWithCount_one: '{{count}} report',
	reportWithCount_other: '{{count}} reports',
	reportWithId: 'Report {{id}}',
	request: 'Request',
	request_one: 'Request',
	request_other: 'Requests',
	requests: 'Requests',
	requestWithCount_one: '{{count}} request',
	requestWithCount_other: '{{count}} requests',
	resource: 'Resource',
	resource_one: 'Resource',
	resource_other: 'Resources',
	resources: 'Resources',
	resourceWithCount_one: '{{count}} resource',
	resourceWithCount_other: '{{count}} resources',
	score: 'Score',
	score_one: 'Score',
	score_other: 'Scores',
	scores: 'Scores',
	segment: 'Segment',
	segment_one: 'Segment',
	segment_other: 'Segments',
	segmentInShort: 'seg',
	segmentCount: 'Segment count',
	segments: 'Segments',
	segmentWithCount_one: '{{count}} segment',
	segmentWithCount_other: '{{count}} segments',
	segmentWithIndex: 'Segment {{index}}',
	source: 'Source',
	status: 'Status',
	subcategories: 'Subcategories',
	subcategory: 'Subcategory',
	subcategory_one: 'Subcategory',
	subcategory_other: 'Subcategories',
	subcategoryWithCount_one: '{{count}} subcategory',
	subcategoryWithCount_other: '{{count}} subcategories',
	submetric: 'Submetric',
	submetric_one: 'Submetric',
	submetric_other: 'Submetrics',
	submetrics: 'Submetrics',
	submetricWithCount_one: '{{count}} submetric',
	submetricWithCount_other: '{{count}} submetrics',
	supplier: 'Supplier',
	template: 'Template',
	token: 'Token',
	token_one: 'Token',
	token_other: 'Tokens',
	tokens: 'Tokens',
	tokenWithCount_one: '{{count}} token',
	tokenWithCount_other: '{{count}} tokens',
	user: 'User',
	user_one: 'User',
	user_other: 'Users',
	users: 'Users',
	userWithCount_one: '{{count}} user',
	userWithCount_other: '{{count}} users',
	utilities: 'Utilities',
	utility: 'Utility',
	utility_one: 'Utility',
	utility_other: 'Utilities',
	utilityStatusItems: {
		deleted: 'Deleted',
		deleting: 'Deleting',
		disabled: 'Disabled',
		enabling: 'Enabling',
		failed: 'Failed',
		hidden: 'Hidden',
		onboarded: 'Onboarded',
		onboarding: 'Onboarding',
		training: 'Training'
	},
	utilityWithCount_one: '{{count}} utility',
	utilityWithCount_other: '{{count}} utilities',
	utilityWithId: 'Utility {{id}}',
	vendor: 'Vendor',
	vendor_one: 'Vendor',
	vendor_other: 'Vendors',
	vendors: 'Vendors',
	vendorWithCount_one: '{{count}} vendor',
	vendorWithCount_other: '{{count}} vendors',
	version: 'Version',
	version_one: 'Version',
	version_other: 'Versions',
	versions: 'Versions',
	versionWithCount_one: '{{count}} version',
	versionWithCount_other: '{{count}} versions'
})

// Export
export default terminology
